module.exports = "data:image/jpeg;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWFnZXMvaGVyb19iYW5uZXJfbGFyZ2UuanBnIjs="


//////////////////
// WEBPACK FOOTER
// ./~/url-loader!./images/hero_banner_large.jpg
// module id = 852
// module chunks = 1